<div style="flex: 1; justify-content: center; align-content: center; ">
    <lottie [path]="lottieConfig.path" [loop]="true"></lottie>
    <h2 style="text-align: center;">Pagina non trovata</h2>
    <div style="flex: 1; justify-content: center; align-items: center; text-align: center;">
        <button (click)="router.navigate(['../Login']);">Torna al login</button>
    </div>
</div>
